import { Dialog, DialogTitle, FormControl, DialogContent, DialogActions } from '@mui/material';
import { Button, Typography } from '@sweep-io/sweep-design';
import { useState } from 'react';
import { SweepObjectSelector } from '../../../../common/sweep-object-field-selectors/SweepObjectSelector';
import FieldLabel from '../../../../common/FieldLabel';

interface NewSfProcessMiningDialogProps {
  crmOrgId: string;
  onCancel: () => any;
  onConfirm: (objectType: string) => any;
  loading: boolean;
}

export const ProcessMiningDialog = ({
  crmOrgId,
  onCancel,
  loading,
  onConfirm,
}: NewSfProcessMiningDialogProps) => {
  const [objectType, setObjectType] = useState<string>('');
  const isValid = objectType !== '';

  return (
    <Dialog
      open
      onClose={onCancel}
      PaperProps={{
        sx: {
          width: '484px',
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h3">New Business Process</Typography>
      </DialogTitle>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          onConfirm(objectType);
        }}
      >
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          <FormControl fullWidth>
            <FieldLabel
              label={'Choose object'}
              infoTooltipTitle={'Salesforce object that represents this funnel'}
              showTooltip
              markLabelAsRequired
            />
            <SweepObjectSelector
              crmOrgId={crmOrgId}
              onChange={(value: string) => {
                setObjectType(value);
              }}
              value={objectType}
              objectTypeFilters={{
                createable: true,
                updateable: true,
                triggerable: true,
                includeBig5: true,
              }}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button variant="system" size="small" onClick={onCancel}>
            Cancel
          </Button>
          <Button htmlType="submit" size="small" loading={loading} disabled={loading || !isValid}>
            Create
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
